import React, { FC } from 'react';
import { ProductMainPrice } from 'src/components/BundleProduct/ProductMainPrice';
import { ProductPrice } from 'src/types/global-types';
import classnames from 'classnames';
import { CircleLoader } from 'src/components/CircleLoader/CircleLoader';

import { BundleButton } from './BundleButton';
import { StepContainer } from './StepContainer';
import classes from './SubmitStep.scss';

type Props = {
    bundlePrice: ProductPrice;
    allCustomisationsCost: number;
    customisationButtonText: string;
    setOpenModal: (boolean) => void;
    formIsValid: boolean;
    customisationEnabled: boolean;
    basketLoading: boolean;
    isBundlePlain: boolean;
};

export const SubmitStep: FC<Props> = ({
    bundlePrice,
    allCustomisationsCost,
    customisationButtonText,
    setOpenModal,
    formIsValid,
    customisationEnabled,
    basketLoading,
    isBundlePlain,
}) => (
    <StepContainer>
        <div
            className={classnames(classes.submitContainer, {
                [classes.plainBundle]: isBundlePlain,
            })}
        >
            {!isBundlePlain && (
                <BundleButton
                    disabled={!customisationEnabled}
                    size="big"
                    background="orange"
                    onClick={() => setOpenModal(true)}
                    icon="v-right.svg"
                    iconOnRight
                    type="button"
                    bold
                >
                    {customisationButtonText}
                </BundleButton>
            )}

            {formIsValid && (
                <div className={classes.price}>
                    <ProductMainPrice
                        price={{
                            price: bundlePrice.final_price + allCustomisationsCost,
                            price_incl: bundlePrice.final_price_incl + allCustomisationsCost,
                        }}
                    />
                </div>
            )}

            {basketLoading ? (
                <div className={classes.loaderWrapper}>
                    <CircleLoader />
                </div>
            ) : (
                <BundleButton
                    type="submit"
                    disabled={!formIsValid}
                    size="big"
                    background="green"
                    icon="basket.svg"
                    bold
                >
                    Add to basket
                </BundleButton>
            )}
        </div>
    </StepContainer>
);
